import React, { PropsWithChildren } from 'react';

import { Alert } from '@zapier/design-system';

type Props = PropsWithChildren<{}>;

export default function Persistent({ children }: Props) {
  return <Alert title="Zapier Partner Sandbox">{children}</Alert>;
}
